import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import { initClickSound } from "@/utils/clickSound";
import App from "@/App";

// Initialize click sound once globally
initClickSound();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
